import { render, staticRenderFns } from "./CodeExampleHeader.vue?vue&type=template&id=739fa1a6&lang=pug&"
import script from "./CodeExampleHeader.vue?vue&type=script&lang=ts&"
export * from "./CodeExampleHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CodeExampleHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports